import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export class Areas extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		const selectionCount = this.selectionTypeCount(filterSelectionState);
		const countrySelected = await this.selectionFor(FilterKey.COUNTRY, filterSelectionState);
		const areaSelected = await this.selectionFor(FilterKey.AREA, filterSelectionState);

		return areaSelected
			&& (selectionCount === 1 || selectionCount === 2 || (countrySelected && selectionCount === 3));
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const singleSelectionForArea = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);

		let location = 'selected areas';
		let area = '';
		if (singleSelectionForArea) {
			area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);

			const countryName = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
			const country = countryName !== '' ? `, ${countryName}` : ``;

			location = `${area}${country}`;
		}

		const seoInfo = `Comprehensive list of universities in ${location}`;

		return Promise.resolve(seoInfo);
	}
}
